/* eslint react-hooks/exhaustive-deps: "warn" */

import { type ReactNode } from 'react';

import { TitleBlock } from 'ui/atoms/TitleBlock/TitleBlock';
import { Section } from 'ui/molecules/Section/Section';

import styles from './ProvenanceSection.module.scss';

export type ProvenanceItem = {
  code: string;
  title: string;
  description: ReactNode;
};

type Props = {
  title: ReactNode;
  description?: ReactNode;
  items: ProvenanceItem[];
  disclaimer?: ReactNode;
};

export const ProvenanceSection = ({ title, description, items, disclaimer }: Props) => (
  <Section background="#161d2b" className={styles.root}>
    <div className={styles.head}>
      <TitleBlock title={title} description={description} theme="dark" align="left" />
    </div>

    <div className={styles.grid}>
      {items.map((item) => (
        <div key={item.code} className={styles.card}>
          <span className={styles.seal} aria-hidden="true">
            {item.code}
          </span>

          <h3 className={styles.cardTitle}>{item.title}</h3>
          <p className={styles.cardDescription}>{item.description}</p>
        </div>
      ))}
    </div>

    {disclaimer && (
      <div className={styles.disclaimer}>
        <p>{disclaimer}</p>
      </div>
    )}
  </Section>
);
